import { render } from "./pairing-people-preview.vue?vue&type=template&id=78d9d3ee&lang=pug"
import script from "./pairing-people-preview.vue?vue&type=script&lang=js"
export * from "./pairing-people-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__